import type { ConversionRuleEntity } from "@models/conversionRuleSchema.model";
import { isUnlistedDimension, type Rule, type RuleGroup } from "./ConversionRuleBuilder";

const OPS_NO_VALUE = new Set(["is_null", "is_not_null"]);

export function isRuleComplete(rule: Rule): boolean {
  if (!rule.entity || !rule.field || !rule.operator) return false;
  if (OPS_NO_VALUE.has(rule.operator)) return true;
  if (rule.operator === "in") {
    return Boolean(rule.value_group) || (Array.isArray(rule.value) && rule.value.length > 0);
  }
  return rule.value !== null && rule.value !== undefined && rule.value !== "";
}

function findRuleIds(group: RuleGroup, matches: (rule: Rule) => boolean): string[] {
  const out: string[] = [];
  const walk = (node: Rule | RuleGroup) => {
    if ("combinator" in node) {
      node.rules.forEach(walk);
    } else if (matches(node)) {
      out.push(node.id);
    }
  };
  walk(group);
  return out;
}

export function findIncompleteRuleIds(group: RuleGroup): string[] {
  return findRuleIds(group, (rule) => !isRuleComplete(rule));
}

// Rules whose stored dimension the picker no longer lists (MPN-1673). A field the schema
// has not loaded is not judged.
export function findUnlistedDimensionRuleIds(
  group: RuleGroup,
  entities: readonly ConversionRuleEntity[],
): string[] {
  return findRuleIds(group, (rule) => {
    const entity = entities.find((e) => e.name === rule.entity);
    return isUnlistedDimension(rule, entity?.fields.find((f) => f.name === rule.field));
  });
}
